import { render, staticRenderFns } from "./common-localphone.vue?vue&type=template&id=c3fd7056"
import script from "./common-localphone.vue?vue&type=script&lang=js"
export * from "./common-localphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports